import { createContext, useContext, useEffect, useState, useCallback } from "react";

// Tema global de la plataforma operativa (Modo Sol / Modo Luna).
// Un único estado compartido entre Terminal y Valet, persistido en localStorage,
// que se aplica instantáneamente en todas las vistas operativas.
const ThemeContext = createContext({ sunMode: false, toggleSunMode: () => {} });
const KEY = "pap_sunmode";

function readInitial() {
  if (typeof localStorage === "undefined") return false;
  const v = localStorage.getItem(KEY);
  // Migración desde la clave previa (Sprint 34.0, exclusiva de Valet).
  if (v === null) return localStorage.getItem("pap_valet_sunmode") === "1";
  return v === "1";
}

export function ThemeProvider({ children }) {
  const [sunMode, setSunMode] = useState(readInitial);

  useEffect(() => {
    try { localStorage.setItem(KEY, sunMode ? "1" : "0"); } catch { /* noop */ }
  }, [sunMode]);

  const toggleSunMode = useCallback(() => {
    // Fundido suave Sol/Luna: activa transiciones de color solo durante el cambio.
    try {
      const body = document.body;
      body.classList.add("theme-fading");
      window.clearTimeout(toggleSunMode._t);
      toggleSunMode._t = window.setTimeout(() => body.classList.remove("theme-fading"), 500);
    } catch { /* noop */ }
    setSunMode((v) => !v);
  }, []);

  return (
    <ThemeContext.Provider value={{ sunMode, toggleSunMode }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  return useContext(ThemeContext);
}
